function getApiBaseUrl(): string {
  // Prefer the API URL baked in at build time (REACT_APP_API_URL). Each
  // environment sets it explicitly with the correct scheme+host — HTTP for
  // local/staging (Traefik "web" entrypoint), HTTPS for production — so the
  // frontend must not override it with a hard-coded https:// guess.
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  const hostname = window.location.hostname.replace(/^(www|app)\./, '');
  if (hostname.endsWith('gym-assist.fit')) {
    return `https://api.${hostname}`;
  }
  return `https://${hostname}`;
}

export const API_BASE_URL = getApiBaseUrl();

export const PROGRESS_ESTIMATION_ENABLED = process.env.REACT_APP_FEATURE_PROGRESS_ESTIMATION !== '0';
